export default "__VITE_ASSET__c36dc8e9__"